module.exports = __webpack_public_path__ + "notif-payments.png?cf8aee10006ba41f082f3c4704a526ea";